import { PrimaryButton } from "components/Button/style";
import styled from "styled-components";
import { Popover } from "react-bootstrap";

export const Container = styled.div`
  margin-top: 2.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Header = styled.h2`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
`;

export const TextoHeader = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;  
  padding-top: 6px;
`;

export const Body = styled.div`
.rdt_TableCell {
  
  div {
    display: flex;
    align-items: center;

    span {
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
      scrollbar-width: none;
    }

    &:hover {
      span {
        text-overflow: clip;
        white-space: normal;
      }
    } 
  }
}
`;

export const Button = styled(PrimaryButton)`
  width: 180px;
  padding: 0.5rem 1rem;
  font-size: 12px !important;
  
`;

export const AtividadesCelula = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;

export const PrimeiraAtividade = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 0 1 auto;
  min-width: 0;
`;

export const PopoverAtividades = styled(Popover)`
  min-width: 220px;

  .popover-body {
    padding: 16px;
  }
`;

export const ListaAtividades = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
`;

export const ItemAtividade = styled.div`
  padding: 8px 14px;
  font-size: 0.85rem;
  background-color: #fff;

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

export const TagAtividadeExtra = styled.span`
  background-color: #f5f5f5;
  border: 1px solid #7f7f7f;
  border-radius: 50px;
  color: #7f7f7f;
  padding: 3px 8px;
  font-size: 0.75rem;
  white-space: nowrap;
  cursor: pointer;
`;
